module.exports = __webpack_public_path__ + "static/32-AUS-BEER.66859241.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/32-AUS-BEER.png
// module id = 631
// module chunks = 35783957827783